import * as Msdyn365 from '@msdyn365-commerce/core';
import { IRegisterSubmitPayload } from '../modules/lxs-register/lxs-register.data';

export interface ISubmitRegisterRequestResponse {
    success: boolean;
    message?: string;
}

const RETENTION_PERIOD_DAYS = 90;

interface ISubmitRegisterRequestFormInput extends IRegisterSubmitPayload {
    ConsentTimestamp: string;
    SubmittedAt: string;
    Locale?: string;
    DeleteAfter: string;
}

interface ISubmitRegisterRequestData {
    '@odata.context': string;
    Success: boolean;
    Message?: string;
}

export class SubmitRegisterRequestInput implements Msdyn365.IActionInput {
    public payload: IRegisterSubmitPayload;
    constructor(payload: IRegisterSubmitPayload) {
        this.payload = payload;
    }
    public getCacheKey = () => 'RegisterSubmitRequestInput';
    public getCacheObjectType = () => 'RegisterSubmitRequestInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (_args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SubmitRegisterRequestInput({} as IRegisterSubmitPayload);
};

async function action(input: SubmitRegisterRequestInput, ctx: Msdyn365.IActionContext): Promise<ISubmitRegisterRequestResponse> {
    const now = new Date();
    const submittedAt = now.toISOString().slice(0, 10);
    const deleteAfterDate = new Date(now);
    deleteAfterDate.setDate(deleteAfterDate.getDate() + RETENTION_PERIOD_DAYS);

    const formInput: ISubmitRegisterRequestFormInput = {
        ...input.payload,
        ConsentTimestamp: submittedAt,
        SubmittedAt: submittedAt,
        Locale: ctx.requestContext.locale,
        DeleteAfter: deleteAfterDate.toISOString().slice(0, 10)
    };

    const response = await Msdyn365.sendRequest<ISubmitRegisterRequestData>(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SubmitRegisterRequest`,
        'post',
        { formInput },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun
            }
        }
    );

    if (response.status !== 200 || !response.data?.Success) {
        return {
            success: false,
            message: response.data?.Message
        };
    }

    return {
        success: true,
        message: response.data.Message
    };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISubmitRegisterRequestResponse>>action,
    id: 'PostRegisterRequest',
    input: createInput
});
